module.exports = __webpack_public_path__ + "img/desktop_dark.e9c1033a.svg";